import { Component } from "react";
import { pstyle } from "../lib/pstyle.js";

// Class component: error boundaries have no hook equivalent in React 18.
// Catches render/lifecycle errors anywhere below <App/> so a bug in one
// screen shows a recoverable message instead of a blank white page.
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[netdoc] uncaught render error:", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={pstyle("min-height:100vh; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:16px; padding:40px; text-align:center; font-family:'IBM Plex Sans', Helvetica, sans-serif;")}>
        <h1 style={pstyle("margin:0; font-size:22px; font-weight:600;")}>Un problème est survenu</h1>
        <p style={pstyle("margin:0; max-width:44ch; font-size:14.5px; line-height:1.6; color:oklch(0.5 0.015 60);")}>
          L'application a rencontré une erreur inattendue. Rechargez la page ; si le
          problème persiste, l'erreur a été notée dans la console de développement.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={pstyle("cursor:pointer; font-size:13.5px; border:1px solid oklch(0.9 0.01 85); border-radius:6px; padding:8px 16px; color:oklch(0.3 0.015 60); background:oklch(1 0 0);")}
        >
          Recharger
        </button>
      </div>
    );
  }
}
